export const GET_HOMECARE_BULK_CANCEL_ORDERS_REQUEST =
  "GET_HOMECARE_BULK_CANCEL_ORDERS_REQUEST";
export const GET_HOMECARE_BULK_CANCEL_ORDERS_SUCCESS =
  "GET_HOMECARE_BULK_CANCEL_ORDERS_SUCCESS";
export const GET_HOMECARE_BULK_CANCEL_ORDERS_FAILURE =
  "GET_HOMECARE_BULK_CANCEL_ORDERS_FAILURE";

export const CANCEL_HOMECARE_BULK_ORDERS_REQUEST =
  "CANCEL_HOMECARE_BULK_ORDERS_REQUEST";
export const CANCEL_HOMECARE_BULK_ORDERS_SUCCESS =
  "CANCEL_HOMECARE_BULK_ORDERS_SUCCESS";
export const CANCEL_HOMECARE_BULK_ORDERS_FAILURE =
  "CANCEL_HOMECARE_BULK_ORDERS_FAILURE";

export const RESET_HOMECARE_BULK_CANCEL_ORDERS =
  "RESET_HOMECARE_BULK_CANCEL_ORDERS";
